import { useEffect } from 'react'

const useSlider = (slideImage, slideText1, slideText2, slideText3, images) => {
    let slideCounter = 0;

    useEffect(() => startSlider())

    const startSlider =() => {
        slideImage.current.style.backgroundImage = `linear-gradient(
            to right,
            rgba(34, 34, 34, 0.4),
            rgba(68, 68, 68, 0.4)
            ), url(${images[0].src})`;
            // slideText.current.innerHTML = images[0].text;
            slideText1.current.innerHTML = images[0].text1
            slideText2.current.innerHTML = images[0].text2
            slideText3.current.innerHTML = images[0].text3
    }

    const handleSlide = (slide) => {
        slideImage.current.style.backgroundImage = `linear-gradient(
            to right,
            rgba(34, 34, 34, 0.4),
            rgba(68, 68, 68, 0.4)
          ), url(${images[slide - 1].src})`;
          // slideText.current.innerHTML = images[slide - 1].text;
          slideText1.current.innerHTML = images[slide - 1].text1;
          slideText2.current.innerHTML = images[slide - 1].text2;
          slideText3.current.innerHTML = images[slide - 1].text3;
         animateSlide(slideImage)
    }

    const animateSlide = () => {
        slideImage.current.classList.add('fadeIn');
        setTimeout(() => {
          slideImage.current.classList.remove('fadeIn');
        }, 700);
    }
    
    const goToPreviousSlide = () => {
        if (slideCounter === 0) {
            handleSlide(images.length)
            slideCounter = images.length;
          }
        
        handleSlide(slideCounter)         
        slideCounter--;
    }

    const goToNextSlide = () => {
      if (slideCounter === images.length - 1) {
        startSlider()
        slideCounter = -1;
        animateSlide(slideImage)
      }

      slideImage.current.style.backgroundImage = `linear-gradient(
          to right,
           rgba(34, 34, 34, 0.4),
          rgba(68, 68, 68, 0.4)
          ),url(${images[slideCounter + 1].src})`;
      // slideText.current.innerHTML = images[slideCounter + 1].text;
      slideText1.current.innerHTML = images[slideCounter + 1].text1;
      slideText2.current.innerHTML = images[slideCounter + 1].text2;
      slideText3.current.innerHTML = images[slideCounter + 1].text3;
      slideCounter++;
      animateSlide(slideImage)
    }

    return { goToPreviousSlide, goToNextSlide }
}

export default useSlider